<template>
    <div class="layout-menu relative">
        <ul class="nav-mobile flex flex-col lg:-mt-10">
            <li
                v-for="(key, index) in navKeys"
                :key="key"
                class="list-item list-item--top block"
                :class="{ 'mt-3 xl:mt-8' : index !== 0 }"
            >
                <a :href="routes[key]" class="list-item__text">
                    <span>{{ $t(`routes.${[key]}`) }}</span>
                </a>
            </li>
            <li class="list-item list-item--bottom mt-10 md:mt-16 xl:mt-24">
                <a :href="routes.wizard" v-ripple class="btn btn-outline-primary font-medium">
                    <span class="mx-auto">{{ $t('reserve') }}</span>
                </a>
            </li>
        </ul>

        <slot class="bottom" name="language-selector-mobile"></slot>
    </div>
</template>

<script>
export default {
    props: {
        routes: {
            type: Object,
            required: true
        },
        username: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            navKeys: ['about', 'menu', 'products', 'gallery', 'events', 'contact'],
        };
    },
};
</script>

<style lang="scss" scoped>
@import "../../../sass/_variables.scss";

.layout-menu {
    --padding-top: 60px;
    --padding-bottom: 90px;

    @media (min-width: 768px) {
        --padding-bottom: 120px;
    }

    display: flex;
    align-items: center;
    justify-content: stretch;
    min-height: 100%;
    padding: var(--padding-top) 0 calc(var(--padding-bottom) + var(--vh-offset, 0px));
    margin-top: calc(var(--padding-top) * -1);

    .nav-mobile {
        max-height: calc(100vh - var(--padding-top) - var(--padding-bottom) - var(--vh-offset, 0px));
        overflow: auto;
        align-items: center;
        width: 100%;

        .list-item {
            display: flex;
            justify-content: center;

            &__text {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                color: $rouge !important;
                font-size: 24px;

                @media (min-width: 1024px) {
                    font-size: 30px;
                }
            }

            .btn {
                height: 58px;
                text-align: center;
                padding: 0 1.5rem;
                transition: none;

                &.btn-white__outlined {
                    border: 1px solid white !important;
                }
            }

            &.list-item--top {
                position: relative;

                a {
                    &::after {
                        position: absolute;
                        bottom: -0.5rem;
                        left: -1rem;
                        right: -1rem;
                        display: block;
                        content: '';
                        height: 3px;
                        background-color: $rouge;
                        width: 0;
                        transition: width 0.3s ease-out;
                    }

                    @media (min-width: 1280px) {
                        bottom: -1rem;
                    }

                    &:hover {
                        &::after {
                            width: calc(100% + 2rem);
                        }
                    }

                    &:active {
                        color: $soft-rouge !important;

                        &::after {
                            width: calc(100% + 2rem);
                            background-color: $soft-rouge !important;
                        }
                    }
                }
            }

            &.list-item--bottom {
                a {
                    font-size: 24px;
                }
            }
        }
    }
}
</style>
